// The ONE Chart.js seam (R-069/D-071): consumers pass labels + series only — no Chart.js types or
// options leak past this component. This file is a LAZY wrapper: chart.js is a heavy dependency, so
// the implementation (`chart-impl.tsx`, which imports chart.js) is loaded on demand only when a chart
// actually renders — screens with no charts don't pull chart.js into the initial bundle (R-105/R-106).
// The exports (`Chart`, `ChartSeries`) are unchanged, so consumers and the barrel need no edits.
import { lazy, Suspense } from 'preact/compat';

export interface ChartSeries {
  label: string;
  /** Fixed per-entity hex (validated for light + dark) — never reassigned by rank. */
  color: string;
  data: number[];
}

export interface ChartProps {
  type: 'line' | 'bar';
  labels: string[];
  series: ChartSeries[];
  height?: number;
}

const ChartImpl = lazy(() => import('./chart-impl').then((m) => ({ default: m.ChartImpl })));

export function Chart(props: ChartProps) {
  // Own Suspense with a height-matched placeholder so only the chart area is blank while chart.js
  // loads — the rest of the page (already painted) is untouched.
  return (
    <Suspense fallback={<div style={{ height: `${props.height ?? 240}px`, width: '100%' }} />}>
      <ChartImpl {...props} />
    </Suspense>
  );
}
